import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { ThemeProvider, applyTheme, getInitialTheme } from "./components/ThemeProvider";
import "./index.css";
import { reportWebVitals } from "./reportWebVitals";

applyTheme(getInitialTheme());

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);

const initializeNonCriticalServices = () => {
  void Promise.all([
    import("./sentry").then((module) => module.initSentry()),
    import("./posthog").then((module) => module.initPosthog()),
  ]);
};

if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => {
      initializeNonCriticalServices();
    });
  } else {
    window.setTimeout(() => {
      initializeNonCriticalServices();
    }, 1);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
